import { memo } from 'react'
import { Link } from "react-router-dom"
import PageMeta from '../components/page-meta'

// Critical above-the-fold image - preload
import FullLogo from "../images/my_mini_prints_logo_header_small.webp"
// Import all other images properly for webpack processing
import Image1 from "../images/Homepage/hand_foot_photo_white_granite_landscape.webp"
import Image1Mobile from "../images/Homepage/hand_foot_photo_white_granite_landscape_mobile.webp"
import Image2 from "../images/Homepage/3d_landscape_hhff_pink_silvercasts.webp"
import Image2Mobile from "../images/Homepage/3d_landscape_hhff_pink_silvercasts_mobile.webp"
import Image3 from "../images/Homepage/IMG_0662.webp"
import Image3Mobile from "../images/Homepage/IMG_0662_mobile.webp"
import Image4 from "../images/Homepage/IMG_3965.webp"
import Image4x1000 from "../images/Homepage/IMG_3965_1000px.webp"
import Image4Mobile from "../images/Homepage/IMG_3965_mobile.webp"
import Image5 from "../images/Homepage/2hands_2feet_photo_oak_cream.webp"
import Image5Mobile from "../images/Homepage/2hands_2feet_photo_oak_cream_mobile.webp"
import Image6 from "../images/Homepage/1024_hhff_photo_portrait_white_silvercasts.webp"
import Image6Mobile from "../images/Homepage/1024_hhff_photo_portrait_white_silvercasts_mobile.webp"
import Image7 from "../images/Homepage/1024_baby_hand_casting.webp"

const HomePage = memo(function HomePage() {
    return <>
        <PageMeta
            description="My Mini Prints produce beautiful high quality hand and foot print casts of your baby and children in Essex. Wide range of frames, mounts, and colours."
            canonical="/"
            image="https://www.myminiprints.co.uk/images/hand_foot_photo_white-pink.webp"
        />

        <div className="container-fluid text-center">
            <div className="row">



            <div className="container" style={{"display" : "flex", "justifyContent" : "center"}} >
                <img
                    src={FullLogo}
                    className="MMP-logo-name img-fluid"
                    alt="My Mini Prints"
                    fetchPriority="high"
                    width="1000"
                    height="498"
                />
            </div>


            <div className="container">
                <br />
                <br />
                <div className="card mx-auto p-0 shadow" style={{"width" : "100%"}}>
                    <h1 className="card-header h1 display-4" style={{"backgroundColor": "#DCE774", "color": "#504E51"}}>Welcome to My Mini Prints</h1>
                    <p className="card-body display-6">Hand and Foot casting</p>
                    <div className="card-body me-auto">

                        My Mini Prints produce beautiful high quality hand and feet print casts of your baby and children. We offer a wide range of frames and mount colours so your keepsake casting is totally bespoke and unique. A wonderful way to remember how little they once were.
                        <br />
                        <br />
                        <picture>
                            <source
                                srcSet={`${Image1Mobile} 600w, ${Image1} 976w`}
                                sizes="(max-width: 768px) 90vw, 80vw"
                                type="image/webp"
                            />
                            <img
                                src={Image1}
                                alt="Hand & foot cast on granite backing"
                                className="MMP-general-image rounded img-fluid"
                                fetchPriority="high"
                                loading="eager"
                                decoding="async"
                                width="976"
                                height="496"
                            />
                        </picture>
                        <br />
                        <br />
                        <img
                            src={Image2}
                            srcSet={`${Image2Mobile} 600w, ${Image2} 1200w`}
                            sizes="(max-width: 768px) 90vw, 80vw"
                            alt="Hand & foot 3D on grey backing"
                            className="MMP-general-image rounded img-fluid"
                            loading="lazy"
                            width="1200"
                            height="800"
                        />
                    </div>
                </div>
                <br />
                <br />
                <div className="card mx-auto p-0 shadow" style={{"width" : "100%"}}>
                    <h2 className="card-header">3D Castings</h2>
                    <div className="card-body">
                        <br />
                        <br />
                        <img
                            src={Image3}
                            srcSet={`${Image3Mobile} 600w, ${Image3} 1200w`}
                            sizes="(max-width: 768px) 90vw, 80vw"
                            alt="Hand and foot casts with a letter in frame"
                            className="MMP-general-image rounded img-fluid"
                            loading="lazy"
                            width="1200"
                            height="1030"
                        />
                        <br></br>
                        <br></br>
                        <img
                            src={Image4}
                            srcSet={`${Image4Mobile} 600w, ${Image4x1000} 1000w, ${Image4} 1200w`}
                            sizes="(max-width: 768px) 90vw, 80vw"
                            alt="Hand and foot casts in a decorative frame"
                            className="MMP-general-image rounded img-fluid"
                            loading="lazy"
                            width="1200"
                            height="1600"
                        />
                    </div>
                </div>
                <br></br>
                <br></br>
                <div className="card mx-auto p-0 shadow" style={{"width" : "100%"}}>
                    <h2 className="card-header">Impressions</h2>
                    <div className="card-body">
                        <br></br>
                        <br></br>
                        <img
                            src={Image5}
                            srcSet={`${Image5Mobile} 600w, ${Image5} 1200w`}
                            sizes="(max-width: 768px) 90vw, 80vw"
                            alt="Hand and feet impressions"
                            className="MMP-general-image rounded img-fluid"
                            loading="lazy"
                            width="1024"
                            height="1536"
                        />
                        <br></br>
                        <br></br>
                        <img
                            src={Image6}
                            srcSet={`${Image6Mobile} 600w, ${Image6} 1200w`}
                            sizes="(max-width: 768px) 90vw, 80vw"
                            alt="Silvered hand and feet impressions"
                            className="MMP-general-image rounded img-fluid"
                            loading="lazy"
                            width="1024"
                            height="1537"
                        />
                    </div>
                </div>
                <br></br>
                <br></br>
                <div className="card mx-auto p-0 shadow" style={{"width" : "100%"}}>
                    <h2 className="card-header">Prices</h2>
                    <div className="card-body">
                            <Link className="btn btn-lg btn-success" role="button" to="prices" >Click for Pricelist</Link>
                    </div>
                </div>
                <br></br>
                <br></br>
                <div className="card mx-auto p-0 shadow" style={{"width" : "100%"}}>
                    <h2 className="card-header">Casting Appointment</h2>
                    <div className="card-body">
                        <p>Suitable from birth to adult. Taking the casts takes minutes, it usually takes longer for you to decide which frame, colour, and layout you would like!</p>
                        <br></br>
                        <br></br>
                        <img
                            src={Image7}
                            alt="A casting appointment in progress"
                            className="MMP-general-image rounded img-fluid"
                            loading="lazy"
                            width="500"
                            height="334"
                        />
                        <br></br>
                        <br></br>
                        <Link className="btn btn-secondary btn-lg btn-success" role="button" to="howtobook#top">Click for Booking instructions</Link>
                    </div>
                </div>
                <br></br>
                <br></br>
            </div>

            </div>
        </div>

    </>
})

export default HomePage
